import { ITableColumn } from "../../../../App/Typings/Table";
import { useGetAllUsersQuery } from "../../../ABAC/AbacAppQueries";
import useCreateUserFormState from "../../../ABAC/UsersPage/State/CreateUserFormState";

export default function useAdminUsersState() {
  const createUserModalTitle = "Create New User";
  const attributeAssignementModalTitle = "Attribute Assignment";

  const { data: users = [], isLoading: usersLoading } = useGetAllUsersQuery();
  const {
    getters: { formik, activeStep, steps },
    handlers: { handleCreateModalClose },
  } = useCreateUserFormState({ isAdminCreation: true });

  const columns: ITableColumn[] = [
    { label: "First Name", propName: "firstName" },
    { label: "Last Name", propName: "lastName" },
    { label: "Email", propName: "emailAddress" },
    { label: "Date Created", propName: "createdDate" },
    { label: "Is Active", propName: "isActive" },
  ];

  return {
    getters: {
      users,
      columns,
      usersLoading,
      createUserModalTitle,
      attributeAssignementModalTitle,
      formik,
      activeStep,
      steps,
    },
    handlers: { handleCreateModalClose },
  };
}
